import findObjectByKey from './findObjectByKey';
import { STATES } from '../constants';

export default function getFullStateName(stateCode) {
  if (!stateCode) return '';
  const obj = findObjectByKey(STATES, 'abbr', stateCode.toUpperCase());
  if (!obj) return '';
  return obj.display;
}
